import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthTokenFacade } from 'src/app/modules/auth/application/auth-token.facade';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authTokenFacade: AuthTokenFacade) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.authTokenFacade.getTokenKonnect();
    const token = this.authTokenFacade.getToken();
    if (
      token &&
      this.authTokenFacade.isTokenValid(token) &&
      (req.url.startsWith(environment.pathService) ||
        req.url.startsWith(environment.pathServiceAv) ||
        req.url.startsWith(environment.pathAgencyEcommerceAPI.findLastMinute))
    ) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(authReq);
    } else if (
      req.url.startsWith(environment.pathService) ||
      req.url.startsWith(environment.pathServiceAv) ||
      req.url.startsWith(environment.pathAgencyEcommerceAPI.findLastMinute)
    ) {
      // Si la URL requiere autenticación pero no hay token válido,
      // continuar sin token (el servidor debería responder con 401)
      console.warn(
        'No hay ningún token válido disponible para la solicitud autenticada:',
        req.url
      );
    }

    return next.handle(req);
  }
}
